import Style from '../AuthCard/index.module.scss';
import {FlexBox} from '../../../../../Components/FlexBox';
import {BarsOutlined} from '@ant-design/icons';
import {Checkbox, Col, message, Row} from 'antd';
import React, {useMemo} from 'react';
import {
    deleteRoleFunction,
    FunctionListTree,
    saveRoleFunction,
} from '../../service';
import useRequestFn from '../../../../../Utils/Hooks/useRequestFn';
import {errorMessage, isTrue} from '../../../../../Utils/common';

interface AuthCardItemProps {
    roleId: string;
    data: FunctionListTree;
    onChange(): void;
}

export function AuthCardItem({roleId, data, onChange}: AuthCardItemProps) {
    const isCheckAll = useMemo(
        () => data.children?.every(item => isTrue(item.selectStatus)),
        [data],
    );

    const allIds = data.children?.map(item => item.id) || [];

    const isSupper = isTrue(data.defaultFlag);

    const [onCheck] = useRequestFn(async (id: string, checked: boolean) => {
        try {
            if (checked) {
                await saveRoleFunction(roleId, [id]);
            } else {
                await deleteRoleFunction(roleId, [id]);
            }
            onChange();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const [onCheckAll] = useRequestFn(async checked => {
        try {
            if (checked) {
                await saveRoleFunction(roleId, allIds);
            } else {
                await deleteRoleFunction(roleId, allIds);
            }
            onChange();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    return (
        <div key={data.code} className={Style.content}>
            <FlexBox className={Style.miniTitle} gap="10px">
                <BarsOutlined /> {data.name}
                <FlexBox
                    color="#ccc"
                    marginLeft="20px"
                    hidden={data.levelType !== 'DIMTYPE100001'}>
                    隐藏菜单
                </FlexBox>
                <FlexBox color="#ccc" marginLeft="20px" hidden={!isSupper}>
                    内置操作项, 且该操作项只有超级管理员有权限
                </FlexBox>
            </FlexBox>

            <table className={Style.table}>
                <tbody>
                    <tr>
                        <td width={200} rowSpan={2}>
                            操作权限
                        </td>
                        <td>
                            <div className={Style.all}>
                                <Checkbox
                                    disabled={isSupper}
                                    checked={isCheckAll}
                                    onChange={e =>
                                        onCheckAll(e.target.checked)
                                    }>
                                    全选
                                </Checkbox>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td className={Style.dataRow}>
                            <Row>
                                {data?.children?.map(item => (
                                    <Col
                                        className={Style.col}
                                        key={item.code}
                                        span={8}>
                                        <Checkbox
                                            checked={isTrue(item.selectStatus)}
                                            disabled={isSupper}
                                            onChange={e =>
                                                onCheck(
                                                    item.id,
                                                    e.target.checked,
                                                )
                                            }>
                                            {item.name}
                                        </Checkbox>
                                    </Col>
                                ))}
                            </Row>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
